import { mapValues, omit, pick } from "lodash";

import serializeAnswers from "../../helpers/serializeAnswers";
import normalizeFieldValue from "../../helpers/normalizeFieldValue";

export const serializeUserFormValues = (form, staticFieldNames) => {
  // Use simple value mapping processing on the static fields that we handle
  // manually in the sign up form, but extract the dynamic answers created
  // through the admin panel and put them in the `answers` key to be processed
  // as such by the mutation backend
  const staticFields = pick(form.fields, staticFieldNames);
  const data = mapValues(staticFields, normalizeFieldValue);

  data.answers = serializeAnswers({
    ...form,
    fields: omit(form.fields, staticFieldNames),
    schema: omit(form.schema, staticFieldNames)
  });

  return data;
};
